// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取商户后台首页看板 GET /api/v1/dashboard/home */
export async function DashboardHomeControllerGetHomeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardHomeControllerGetHomeV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputDashboardHomeDto>(
    "/api/v1/dashboard/home",
    {
      method: "GET",
      params: {
        // totalRange has a default value: all
        totalRange: "all",

        ...params,
      },
      ...(options || {}),
    }
  );
}
